const TinhTongGia = (data, name) => {
  if (data) {
    let tongGia = 0;
    
    data.forEach((goiDichVu) => {
      tongGia += goiDichVu[name];
    });
    
    return tongGia;
  } else null;
};

export default TinhTongGia;
